import React from "react";
import NoRecordFound from "../Common/NoRecordFound";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Alerts = () => {
  const { t } = useTranslation();
  const ALERTS_DATA = [
    {
      id: 1,
      title: t("Manuel Queue Time Increase"),
      value: t("10 min"),
      store: t("Store - Al arid, Riyadh"),
      time: t("1 min ago"),
      type: "error", // error | success
    },
    {
      id: 2,
      title: t("System Operations Started"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "success",
    },
    {
      id: 3,
      title: t("Manuel Intervention"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "error",
    },
    {
      id: 4,
      title: t("Manuel Queue Time Increase"),
      value: t("10 min"),
      store: t("Store - Al arid, Riyadh"),
      time: t("1 min ago"),
      type: "error", // error | success
    },
    {
      id: 5,
      title: t("System Operations Started"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "success",
    },
    {
      id: 6,
      title: t("Manuel Intervention"),
      store: t("Store - Al arid, Riyadh"),
      time: t("5 min ago"),
      type: "error",
    },
  ];

  return (
    <div className="alerts dashboard_common_card">
      <div className="alerts__header">
        <h3 className="fs_20">{t("Alerts")}</h3>
        <Link to={"/overview/alerts"}>
          <button className="alerts__view">{t("View All")}</button>
        </Link>
      </div>

      <div className="alerts__list common_scrollbar">
        {ALERTS_DATA?.length === 0 ? (
          <NoRecordFound title={t("No alerts found")} />
        ) : (
          ALERTS_DATA?.map((alert) => (
            <div
              key={alert.id}
              className={`alert_card alert_card--${alert.type}`}
            >
              <div className="alert_card__content">
                <h4>{alert.title}</h4>

                {alert.value && (
                  <p className="alert_card__value">{alert.value}</p>
                )}

                <p className="alert_card__store">{alert.store}</p>
              </div>

              <span className="alert_card__time">{alert.time}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Alerts;
